(function() {
  'use strict';

  var state = {
    view: 'home',
    step: 0,
    history: []
  };

  var views = {};
  var header = null;
  var footer = null;
  var modal = null;
  var form = null;

  // Tracks whether a navigation is currently being attempted from a
  // confirm-leave view, so popstate handlers can detect their own actions.
  var bypassConfirm = false;

  function init() {
    header = document.querySelector('[data-winx-header]');
    footer = document.querySelector('[data-winx-footer]');
    modal = document.querySelector('[data-winx-modal]');
    form = document.getElementById('winx-app-form');

    // Block accidental form submission — the form is only used for state.
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
      });
    }

    function collectViews() {
      views = {};
      document.querySelectorAll('[data-winx-view]').forEach(function(el) {
        var view = el.getAttribute('data-winx-view');
        var step = parseInt(el.getAttribute('data-winx-step') || '0', 10);
        if (!views[view]) views[view] = {};
        views[view][step] = el;
      });
    }

    collectViews();

    // Footer tab clicks — leaving the current flow, requires confirm
    if (footer) {
      footer.querySelectorAll('[data-winx-tab]').forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          var view = this.getAttribute('data-winx-tab');
          attemptLeave(function() { navigateTo(view, 0); });
        });
      });
    }

    // Back & close buttons — both are "leaving" actions, require confirm
    if (header) {
      var backBtn = header.querySelector('[data-winx-back]');
      if (backBtn) {
        backBtn.addEventListener('click', function(e) {
          e.preventDefault();
          goBack();
        });
      }

      var closeBtn = header.querySelector('[data-winx-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          attemptLeave(function() { navigateTo('home', 0); });
        });
      }
    }

    // Forward navigation buttons (next / goto) — these go forward
    // through the flow and never trigger the cancel modal
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-winx-next]');
      if (btn) {
        e.preventDefault();
        var nextStep = parseInt(btn.getAttribute('data-winx-next'), 10);
        if (!isNaN(nextStep)) {
          navigateTo(state.view, nextStep);
        } else {
          navigateTo(state.view, state.step + 1);
        }
        return;
      }

      var goBtn = e.target.closest('[data-winx-goto]');
      if (goBtn) {
        e.preventDefault();
        var target = goBtn.getAttribute('data-winx-goto');
        var parts = target.split(':');
        var view = parts[0];
        var step = parts[1] ? parseInt(parts[1], 10) : 0;
        navigateTo(view, step);
      }
    });

    // Browser back button
    window.addEventListener('popstate', function(e) {
      var newState = e.state && e.state.winx ? e.state.winx : { view: 'home', step: 0 };

      // If the current view requires confirmation and this isn't a confirmed
      // navigation, push the current state back and show the modal.
      if (!bypassConfirm && currentRequiresConfirm()) {
        // Re-push the current state to "cancel" the popstate
        var current = { winx: { view: state.view, step: state.step } };
        try {
          window.history.pushState(current, '', stepUrl(state.view, state.step));
        } catch (e) {}
        showConfirmModal(function() {
          // User confirmed: go back via history.back()
          bypassConfirm = true;
          window.history.back();
          // Reset bypass after the next popstate fires
          setTimeout(function() { bypassConfirm = false; }, 100);
        });
        return;
      }

      bypassConfirm = false;
      state.view = newState.view;
      state.step = newState.step;
      render();
    });

    // beforeunload — browser-level refresh/close warning
    window.addEventListener('beforeunload', function(e) {
      if (currentRequiresConfirm()) {
        e.preventDefault();
        return '';
      }
    });

    // Modal button handlers
    if (modal) {
      var primary = modal.querySelector('[data-winx-modal-primary]');
      var secondary = modal.querySelector('[data-winx-modal-secondary]');
      var backdrop = modal.querySelector('[data-winx-modal-backdrop]');

      if (primary) {
        primary.addEventListener('click', function() {
          // "Return to test" — cancel the leave attempt
          hideConfirmModal();
        });
      }
      if (secondary) {
        secondary.addEventListener('click', function() {
          // "Cancel test" — proceed with the leave
          var cb = pendingNavigate;
          hideConfirmModal();
          if (cb) cb();
        });
      }
      if (backdrop) {
        backdrop.addEventListener('click', function() {
          // Tapping outside is the same as "return to test"
          hideConfirmModal();
        });
      }
    }

    // Theme editor: jump to the section being edited so it appears on
    // screen instead of below the active view.
    if (window.Shopify && Shopify.designMode) {
      function navigateToElement(el) {
        if (!el) return;
        // The event target can be the section wrapper (ancestor of the view),
        // the view element itself, or a block inside the view. Cover all cases.
        var viewEl = null;
        if (el.matches && el.matches('[data-winx-view]')) {
          viewEl = el;
        } else if (el.closest) {
          viewEl = el.closest('[data-winx-view]');
        }
        if (!viewEl && el.querySelector) {
          viewEl = el.querySelector('[data-winx-view]');
        }
        if (!viewEl) return;
        var view = viewEl.getAttribute('data-winx-view');
        var step = parseInt(viewEl.getAttribute('data-winx-step') || '0', 10);
        if (view && (view !== state.view || step !== state.step)) {
          navigateTo(view, step);
        } else {
          // Same view — just re-render to ensure display is synced.
          render();
        }
      }
      document.addEventListener('shopify:section:select', function(e) {
        navigateToElement(e.target);
      });
      document.addEventListener('shopify:section:load', function(e) {
        // The section's DOM was replaced; rebuild the views map so we
        // reference the new element, then navigate to it.
        collectViews();
        navigateToElement(e.target);
      });
      document.addEventListener('shopify:block:select', function(e) {
        navigateToElement(e.target);
      });
    }

    // Set initial state from the URL, so a step URL can be opened directly
    // (shared, bookmarked, or clicked out of a Clarity funnel).
    //
    // A view that isn't on this page — an old link, a typo, a step that has
    // since been removed — falls back to the dashboard. Without this every
    // section renders hidden and the page comes up blank.
    var params = new URLSearchParams(window.location.search);
    var initialView = params.get('step') || 'home';
    var initialStep = parseInt(params.get('substep') || '0', 10);
    if (isNaN(initialStep)) initialStep = 0;

    if (!viewExists(initialView, initialStep)) {
      initialView = 'home';
      initialStep = 0;
    }

    navigateTo(initialView, initialStep, true);
  }

  function getActiveSection() {
    if (!views[state.view]) return null;
    return views[state.view][state.step] || null;
  }

  function currentRequiresConfirm() {
    var el = getActiveSection();
    return !!(el && el.getAttribute('data-winx-confirm-leave') === 'true');
  }

  // Tracks the next navigation action to run if the user confirms
  var pendingNavigate = null;

  // Used for "leaving" actions only (back, close, footer tab, popstate).
  // Forward navigation (next/goto) skips the modal entirely.
  function attemptLeave(action) {
    if (currentRequiresConfirm()) {
      showConfirmModal(action);
    } else {
      action();
    }
  }

  function showConfirmModal(onConfirm) {
    if (!modal) {
      // No modal element — just confirm immediately
      if (onConfirm) onConfirm();
      return;
    }
    pendingNavigate = onConfirm;
    modal.setAttribute('data-winx-modal-open', '');
  }

  function hideConfirmModal() {
    if (!modal) return;
    modal.removeAttribute('data-winx-modal-open');
    pendingNavigate = null;
  }

  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  function viewExists(view, step) {
    return !!(views[view] && views[view][step]);
  }

  // Build the URL for a view/step. Every other query parameter is carried
  // across untouched: the app is linked with UTM parameters, and the
  // telehealth links read them, so navigation must not drop them.
  //
  // The dashboard is the bare URL. Every other view names itself, which is
  // what lets Microsoft Clarity treat the flow steps as separate pages.
  //
  // The parameter is 'step', NOT 'view': ?view= is reserved by Shopify to
  // select an alternate template, so /pages/winx-app?view=uti-steps makes
  // Shopify look for a page.winx-app.uti-steps template, fail to find one,
  // and render a default page template with none of the app sections on it.
  function stepUrl(view, step) {
    var params = new URLSearchParams(window.location.search);

    if (view === 'home' && !step) {
      params.delete('step');
      params.delete('substep');
    } else {
      params.set('step', view);
      // Nearly every view is a section of its own at step 0; only include
      // the sub-step when it actually distinguishes something.
      if (step) {
        params.set('substep', step);
      } else {
        params.delete('substep');
      }
    }

    var query = params.toString();
    return window.location.pathname + (query ? '?' + query : '') + window.location.hash;
  }

  function navigateTo(view, step, replace) {
    // Push current state to history before navigating
    if (!replace) {
      state.history.push({ view: state.view, step: state.step });
    }

    state.view = view;
    state.step = step;

    // Update browser history
    // The URL is a readout of the state, not the source of truth. If the
    // history API refuses the write, the step must still render: this is a
    // medical test flow, and stranding someone mid-test is far worse than
    // an address bar that stopped updating.
    var historyState = { winx: { view: view, step: step } };
    try {
      var url = stepUrl(view, step);
      if (replace) {
        window.history.replaceState(historyState, '', url);
      } else {
        window.history.pushState(historyState, '', url);
      }
    } catch (e) {}

    render();
    scrollToTop();
  }

  function goBack() {
    if (state.history.length > 0) {
      var prev = state.history.pop();
      state.view = prev.view;
      state.step = prev.step;

      var historyState = { winx: { view: state.view, step: state.step } };
      try {
        window.history.replaceState(historyState, '', stepUrl(state.view, state.step));
      } catch (e) {}

      render();
      scrollToTop();
    } else {
      navigateTo('home', 0);
    }
  }

  function render() {
    var isDashboard = state.view === 'home' && state.step === 0;

    // When returning to the dashboard, reset the form so a new test
    // starts with a clean slate (no carry-over from a cancelled run).
    if (isDashboard && form) {
      form.reset();
    }

    // Toggle body class so the shell can swap site chrome <-> app chrome
    document.body.classList.toggle('winx-app--in-flow', !isDashboard);

    // Show/hide content sections; track the active one for config reads
    var activeEl = null;
    Object.keys(views).forEach(function(viewName) {
      Object.keys(views[viewName]).forEach(function(stepNum) {
        var el = views[viewName][stepNum];
        var isActive = viewName === state.view && parseInt(stepNum, 10) === state.step;
        el.style.display = isActive ? '' : 'none';
        if (isActive) activeEl = el;
      });
    });

    // Read per-view header config from the active section (data attrs)
    var headerTitle = activeEl ? activeEl.getAttribute('data-winx-header-title') : null;
    var headerShowBack = activeEl ? activeEl.getAttribute('data-winx-header-show-back') : null;
    var headerShowClose = activeEl ? activeEl.getAttribute('data-winx-header-show-close') : null;
    var hideChat = activeEl ? activeEl.getAttribute('data-winx-hide-chat') === 'true' : false;
    var hidePopups = activeEl ? activeEl.getAttribute('data-winx-hide-popups') === 'true' : false;

    // Toggle body classes for hiding third-party widgets
    document.body.classList.toggle('winx-hide-chat', hideChat);
    document.body.classList.toggle('winx-hide-popups', hidePopups);

    // When BOTH third-party widgets are hidden, lower fixed bottom CTAs
    // since there's no chat bubble to clear.
    document.body.classList.toggle('winx-widgets-hidden', hideChat && hidePopups);

    // Show/hide the custom winx-app header
    // (hidden on dashboard so the site header can show)
    if (header) {
      header.style.display = isDashboard ? 'none' : '';

      var dashboardEl = header.querySelector('[data-winx-header-dashboard]');
      var standardEl = header.querySelector('[data-winx-header-standard]');

      if (dashboardEl && standardEl) {
        dashboardEl.style.display = isDashboard ? '' : 'none';
        standardEl.style.display = isDashboard ? 'none' : '';
      }

      // Update header title from the active section
      var titleEl = header.querySelector('.winx-header__title');
      if (titleEl && headerTitle) {
        titleEl.textContent = headerTitle;
      }

      // Update back button visibility
      var backBtn = header.querySelector('[data-winx-back]');
      if (backBtn) {
        var showBack;
        if (headerShowBack !== null) {
          showBack = headerShowBack === 'true';
        } else {
          showBack = state.history.length > 0 && !isDashboard;
        }
        backBtn.style.visibility = showBack ? 'visible' : 'hidden';
      }

      // Update close button visibility
      var closeBtn = header.querySelector('[data-winx-close]');
      if (closeBtn) {
        var showClose;
        if (headerShowClose !== null) {
          showClose = headerShowClose === 'true';
        } else {
          showClose = !isDashboard;
        }
        closeBtn.style.visibility = showClose ? 'visible' : 'hidden';
      }
    }

    // The tab-nav footer is no longer used anywhere — always hide it.
    // Section code is kept for future use.
    if (footer) {
      footer.style.display = 'none';
    }
  }

  // Init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
